
import { Component, Prop, Vue } from 'vue-property-decorator'
import Radio from '~/components/common/input/Radio.vue'

@Component({
  name: 'DeadlineFilterBar',
  components: {
    Radio
  }
})
export default class DeadlineFilterBar extends Vue {
  @Prop({ type: Object, required: true }) filterSpec!: any
  @Prop({ required: true }) selectionOptions!: string[]
}
